export default __webpack_public_path__ + "static/media/refpredictor.011d116a.svg";